// extracted by mini-css-extract-plugin
module.exports = {"openDrawerIcon":"collapsed-workspace-cta_openDrawerIcon_1G8"};